import { Col, Row } from "react-bootstrap";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { NFDateInput } from "../../../Shared/NewForms/NFDateInput";
import { NFLookupInput } from "../../../Shared/NewForms/NFLookupInput";
import { EnumHelper } from "../../../../helpers/EnumHelper";
import { useTranslation } from "react-i18next";

const CashierShiftDetailMain = () => {
  const {t} = useTranslation()
  return (
    <>
      <Row>
        <Col sm={6}>
          <NFTextInput title={t("Name")} fieldName={"name"} />
        </Col>
        <Col sm={6}>
          <NFTextInput title={t("UniqueCode")} fieldName={"uniqueCode"} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFDateInput title={t("cashShiftStart")} fieldName="cashShiftStart" disabled />
        </Col>
        <Col sm={6}>
          <NFDateInput title={t("cashShiftEnd")} fieldName="cashShiftEnd" disabled />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFLookupInput title={t("Status")} fieldName={"status"} items={EnumHelper.CashierShiftStatusTypeEnum()} />
        </Col>
      </Row>
    </>
  );
};

export default CashierShiftDetailMain;
